import { render } from "./OLookupMemberTier.vue?vue&type=template&id=3dd24dac"
import script from "./OLookupMemberTier.vue?vue&type=script&lang=js"
export * from "./OLookupMemberTier.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__